import PayableModule from "@/components/PayableModule";
import { Landmark } from "lucide-react";

export default function Taxes() {
  return (
    <PayableModule
      endpoint="taxes"
      title="Impôts & taxes"
      subtitle="TVA, IS, patente… déclarations et échéances fiscales"
      icon={Landmark}
      entityLabel="tax"
      emptyForm={{ type_impot: "", periode: "", base: 0, taux: 0, montant: 0, echeance: "", notes: "" }}
      fields={[
        { key: "type_impot", label: "Type d'impôt / taxe", type: "select", optionsKey: "tax_types", required: true, span: 2 },
        { key: "periode", label: "Période (ex: Juin 2026 / T2 2026)" },
        { key: "base", label: "Base imposable (FCFA)", type: "number" },
        { key: "taux", label: "Taux (%)", type: "number" },
        { key: "montant", label: "Montant dû (FCFA)", type: "number", required: true },
        { key: "date", label: "Date", type: "date" },
        { key: "echeance", label: "Échéance", type: "date" },
        { key: "notes", label: "Notes", type: "textarea", span: 2 },
      ]}
      columns={[
        { label: "Type", render: (r) => <span className="font-semibold">{r.type_impot}</span> },
        { label: "Période", render: (r) => <span className="text-sm text-slate-600">{r.periode || "—"}</span> },
        { label: "Taux", render: (r) => <span className="text-sm">{r.taux ? `${r.taux}%` : "—"}</span> },
      ]}
    />
  );
}
